import FormattedMessage from 'I18n/components/FormattedMessage';
import { Flex } from 'foundations-components/components/Flex';
import { Text } from 'foundations-components/components/Text';
import { View } from 'foundations-components/components/View';
import phoneTranslations from 'i2l?query=sporks!../../lang/phoneSupport/en.lyaml';
import { useMediaByType } from 'pricing-pages-ui-components/hooks/useMedia';
import { useScopedTranslations } from 'pricing-pages-ui-components/i18n/useScopedTranslations';
import PhoneNumber from 'pricing-pages-ui-components/phone-support/PhoneNumber';
import { PageSection } from 'pricing-pages-ui-components/semantic/PageSection';
import { useContext, useEffect, useRef } from 'react';
import { useCurrency } from '../context/CurrencyContext';
import { PublicI18nContext } from '../context/I18nContext';
import { useInViewport } from '../hooks/useInViewport';
import { usePublicPhoneNumber } from '../hooks/usePublicPhoneNumber';
import { TRACKING_SOURCES, trackCommunicationMethodsInteraction } from '../utils/tracking';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const TRACKING_SOURCE = TRACKING_SOURCES.CONTENT_FOOTER;
const PublicPhoneSupportFooter = () => {
  const isTabletOrSmaller = useMediaByType('tablet');
  const {
    i18nLoader
  } = useContext(PublicI18nContext);
  const T = useScopedTranslations(phoneTranslations, i18nLoader);
  const sectionRef = useRef(null);
  const isInViewport = useInViewport(sectionRef);
  const {
    phoneNumber,
    isReady
  } = usePublicPhoneNumber({
    skip: !isInViewport
  });
  const {
    countryCode
  } = useCurrency();
  const hasTrackedRef = useRef(false);
  useEffect(() => {
    if (isReady && !hasTrackedRef.current) {
      hasTrackedRef.current = true;
      trackCommunicationMethodsInteraction({
        action: 'phone-element-shown',
        supportPhoneNumber: phoneNumber,
        trackingSource: TRACKING_SOURCE
      });
    }
  }, [isReady, phoneNumber]);
  if (!isInViewport) {
    return /*#__PURE__*/_jsx("div", {
      ref: sectionRef
    });
  }
  return /*#__PURE__*/_jsx(PageSection, {
    children: /*#__PURE__*/_jsx("div", {
      ref: sectionRef,
      children: /*#__PURE__*/_jsxs(Flex, {
        display: "flex",
        flexWrap: "wrap",
        alignItems: "center",
        flexDirection: isTabletOrSmaller ? 'column' : 'row',
        justifyContent: isTabletOrSmaller ? 'center' : 'space-between',
        children: [/*#__PURE__*/_jsx(View, {
          maxInlineSize: "600px",
          inlineSize: isTabletOrSmaller ? '100%' : '70%',
          textAlign: isTabletOrSmaller ? 'center' : 'left',
          children: /*#__PURE__*/_jsx(T.Skeleton, {
            widths: ['90%'],
            heights: [32],
            children: /*#__PURE__*/_jsx(Text, {
              as: "h2",
              "data-selenium-id": "phone-support-footer-header",
              typography: "heading-400",
              textWrap: "wrap",
              children: /*#__PURE__*/_jsx(FormattedMessage, {
                message: "phoneSupport.stillHaveQuestions"
              })
            })
          })
        }), isReady && /*#__PURE__*/_jsx(Flex, {
          alignItems: "center",
          display: "inline-flex",
          children: /*#__PURE__*/_jsx(PhoneNumber, {
            phoneNumber: phoneNumber,
            countryCode: countryCode,
            onPhoneNumberClick: () => trackCommunicationMethodsInteraction({
              action: 'phone-number-clicked',
              value: phoneNumber,
              supportPhoneNumber: phoneNumber,
              trackingSource: TRACKING_SOURCE
            })
          })
        })]
      })
    })
  });
};
export default PublicPhoneSupportFooter;